import { render, staticRenderFns } from "./FilesDashboard.vue?vue&type=template&id=0c928021&"
import script from "./FilesDashboard.vue?vue&type=script&lang=js&"
export * from "./FilesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports